import { MyOrganizations } from './MyOrganizations';
export default MyOrganizations;
